import { MenuItem } from "primeng/api";

export class DynamicAction {
    label?: string;

    action?: <T, U>(param: T | void) => U | void;
    onShowMenuAction?: <T, U>(param: T | void) => U | void;
    classes?: string;
    iconPos?: 'left' | 'right' | 'top' | 'bottom';
    icon?: string;
    disabled?: boolean;
    raised?: boolean;
    rounded?: boolean;
    text?: boolean;
    plain?: boolean;
    severity?: '' | 'secondary' | 'success' | 'info' | 'warning' | 'help' | 'danger' | 'violet' | 'midnightblue';
    outlined?: boolean;
    link?: boolean;
    disableOn?: Array<string>;
    disableOnAsync?: <T, U>(param: T | void) => boolean;
    setVisible?: () => boolean;
    submenu?: Array<MenuItem>;

    constructor(source: Partial<DynamicAction>) {
        this.iconPos = 'left';
        this.severity = '';
        this.rounded = false;
        this.setVisible = () => true;
        Object.assign(this, source);
    }
}